function closeMenu(): void {
  const nav = document.querySelector<HTMLElement>("nav .nav-links");
  const btn = document.querySelector<HTMLElement>(".hamburger");
  if (nav && nav.classList.contains("open")) {
    nav.classList.remove("open");
    btn?.setAttribute("aria-expanded", "false");
  }
}

export function toggleMenu(): void {
  const nav = document.querySelector<HTMLElement>("nav .nav-links");
  const btn = document.querySelector<HTMLElement>(".hamburger");
  if (!nav || !btn) return;
  const expanded = btn.getAttribute("aria-expanded") === "true";
  btn.setAttribute("aria-expanded", String(!expanded));
  nav.classList.toggle("open");
}

export function initMenu(): void {
  document.addEventListener("click", (e: MouseEvent) => {
    const nav = document.querySelector<HTMLElement>("nav .nav-links");
    const btn = document.querySelector<HTMLElement>(".hamburger");
    if (!nav || !btn) return;
    if (!nav.classList.contains("open")) return;
    const target = e.target as Node;
    if (!nav.contains(target) && !btn.contains(target)) {
      closeMenu();
    }
  });

  document.querySelectorAll<HTMLAnchorElement>("nav .nav-links a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });
}
